export const ANIMATION_PACE = 1.6
